import * as z from "zod";
import { rateGridSchema } from "./rate-grid-schema";

export type { CellSamples, RateGrid, SampleShipment } from "./rate-grid-schema";

const columnMappingSchema_ = z.object({
  weightColumn: z.string(),
  weightUnit: z.enum(["lb", "oz", "kg", "g"]),
  zoneColumn: z.string().nullable(),
  destinationZipColumn: z.string().nullable(),
  priceColumn: z.string(),
  serviceLevelColumn: z.string().nullable(),
  dateColumn: z.string().nullable(),
  trackingColumn: z.string().nullable(),
  carrierColumn: z.string().nullable(),
});
export type ColumnMapping = z.infer<typeof columnMappingSchema_>;

export const parseCarrierInvoiceCsv = {
  name: "parseCarrierInvoiceCsv" as const,
  input: z.object({
    teamId: z.string().nullable().optional(),
    weightBuckets: z.array(z.number()).optional(),
    originZip: z.string().optional(),
    uploadedFileUrl: z.string().nullable().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    columnMapping: columnMappingSchema_.nullable(),
    rateGrid: rateGridSchema.nullable(),
    totalShipments: z.number(),
    serviceLevelStats: z
      .object({ Standard: z.number(), Plus: z.number(), Express: z.number() })
      .nullable(),
    oldestShipmentDate: z.string().nullable(),
    newestShipmentDate: z.string().nullable(),
    destinationZips: z.array(z.string()).nullable(),
    parseErrors: z.array(z.string()),
    error: z.string().nullable(),
    uploadedFileUrl: z.string().nullable(),
  }),
  files: true,
};
